module.exports = new __parcel__URL__("battleroyale_kills_button_inactive.da30fbd3.png").toString();